import { $t } from 'src/plugins/i18n'
import type { ProxyRecord } from 'src/services/deserializers/deserializers.types'
import type {
  ContextualFieldInterface,
  FieldInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'
import { valueIsEmpty } from 'src/tpbp-core/utils/common.utils'
import type { PersonModel } from 'src/tpbp-json-api-handler/models/models'
import { getContextualFields } from 'src/utils/fieldRules/fieldRules.utils'

function getDefaultValue(
  field: ContextualFieldInterface,
  defaultValues?: Record<string, unknown>,
) {
  const { key, enums, originKey } = field

  if (defaultValues) {
    const hasDefaultValue =
      Object.hasOwn(defaultValues, key) ||
      Object.hasOwn(defaultValues, originKey)
    if (hasDefaultValue) {
      return defaultValues[key] ?? defaultValues[originKey]
    }
  }
  if (enums && enums.length === 1) {
    const value = enums[0]
    if (typeof value === 'object' && value !== null) {
      return value.key
    }

    return value
  }
  if (Object.hasOwn(field, 'default')) {
    return field.default
  }
  return
}

export function setDefaultValues(
  record: ProxyRecord,
  fields: (FieldInterface | ContextualFieldInterface)[],
  defaultValues?: Record<string, unknown>,
) {
  for (const field of fields) {
    if (record.$hasValue(field as unknown as string)) continue

    const { key } = field
    const value = getDefaultValue(
      field as ContextualFieldInterface,
      defaultValues,
    )

    if (value !== undefined) {
      record[key] = value
    }
  }
}

// TODO mutualize with getFieldRules()
export function checkRecord(record, currentUser: PersonModel | null) {
  const fields = getContextualFields(record, currentUser)

  record.$clearErrors()

  for (const field of fields) {
    const value = record[field.key]
    const isMissing =
      field.status === FIELD_RULES.isMandatory && valueIsEmpty(value)

    if (isMissing) {
      record.$setError(field.key, $t('common.errors.missing-required-field'))
    }
  }

  return !record.$hasErrors
}
